<template>
	<v-list dense rounded v-if="data">
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					v-model="data.Attributes.name"
					label="Full Name"
					required
					:rules="[(v) => !!v || 'Name is mandatory']"
					prepend-icon="mdi-badge-account"
					filled
				/>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					v-model="data.Username"
					:rules="[(v) => !!v || 'Username is mandatory']"
					required
					label="Username"
					prepend-icon="mdi-account-key"
					filled
					:disabled="isEditing"
				/>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					:rules="[(v) => !!v || 'Email address is mandatory']"
					class="fullwidth"
					filled
					type="email"
					label="Email-address"
					prepend-icon="mdi-email"
					required
					v-model="data.Attributes.email"
				></v-text-field>
				<i>Upon creating a new user or changing email address of an existing one, an email with a temporary user password will be sent to this address.</i>
			</v-list-item-content>
		</v-list-item>

		<!-- <v-list-item>
				<v-list-item-content>
					<v-text-field
						v-model="data.phone_number"
						label="Phone Number (optional)"
						prepend-icon="mdi-phone"
						filled
					/>
				</v-list-item-content>
			</v-list-item> -->
	</v-list>
</template>

<script>
export default {
	name: 'UserForm',
	props: {
		data: Object,
		disableUsername: Boolean,
	},
	data() {
		return {
			isEditing: false,
		}
	},
	mounted() {
		const { Username } = this.data
		if (Username) this.isEditing = true
	},
}
</script>

<style lang="scss" scoped>
</style>